import React, { Component, createRef } from 'react'
import { Link } from 'react-router-dom'
import { Image } from '@sitecore-jss/sitecore-jss-react';

import { initAoxInViewport, destroyAoxInViewport } from '../../utilities/FrontFunctions/AoxInViewportClass'

import '../../../src/assets/css/0020_objects/1030_obj_push.css'
import '../../../src/assets/css/0010_sections/0490_section_push-hero.css'


class SectionPushHero2026 extends Component {
	constructor(props) {
		super(props)

		this.sectionRef = createRef()
		this.viewportObserver = null
		
		this.state = {
			isVisible: false,
		}
	}
	componentDidMount() {
		this.viewportObserver = initAoxInViewport({
			element: this.sectionRef.current,
			threshold: 0.2,
			rootMargin: '0px 0px -80px 0px',
			once: true,
			onEnter: () => {
				this.setState({ isVisible: true })
			}
		})
	}

	componentWillUnmount() {
		destroyAoxInViewport(this.viewportObserver)
	}


	render() {
		const {scDatas} = this.props;
		const { isVisible } = this.state

		return (
			<section ref={this.sectionRef} className={`obj_section section_push-hero ${isVisible ? 'is-visible' : ''}`}>
				<div className='ctn_section'>

					{ scDatas.BrandList?.children.slice(1, 5).map((brandItem, index) => 
						<div
							key={index}
							className={`obj_push push--hero animation_reveal-item animation_reveal--fade-up animation_delay-${index + 2}`}
						>
							<Link to={brandItem.url}>
								<div className='ctn_push'></div>
								<div className='ctn_background'>
									<div className='obj_image image_cover'>
										<picture className='ctn_image fade-in'>
                                            <source srcSet={brandItem.imagePushMobileHome.jss.value.src} media="(max-width:767px)" />
                                            <Image field={brandItem.imagePushHome.jss}></Image>
										</picture>
									</div>
								</div>
							</Link>
						</div>
					)}

				</div>
			</section>
		)
	}
}

export default SectionPushHero2026